const palette = {
  black: '#000',
  white: '#fff',
  gray: '#d8d8d8',
  red: '#f00',
};

export default palette;
